































// Importing components
import TheFormRegister from '@/components/auth/TheFormRegister.vue';
import BaseAlertList from '@/ui/BaseAlertList.vue';
// Importing functions
import {validateRegisterForm} from '@/ts/auth/validate-register';
import {postRegister} from '@/ts/auth/post-register';
import {getCurrentUser} from '@/ts/other/additional';

export default {
    name: 'PageRegister',
    components: {
        BaseAlertList,
        TheFormRegister,
    },
    props: {},
    data() {
        return {
            errors: Array(),
            data: Object(),
        };
    },
    mounted() {
        this.data = {
            first_name : '',
            last_name : '',
            email : '',
            phone : '',
            password : '',
            password_confirmation : '',
        };
    },
    methods : {
        onSubmit() {
            this.errors = [];

            validateRegisterForm(this.errors, this.data);

            if (this.errors.length === 0) {
                this.$store.dispatch('setLoadingOn');
                postRegister(this.errors, this.data).then(() => {
                    getCurrentUser().then((response) => {
                        localStorage.setItem('permissions', Array(response).join());
                    });
                    // Redirect user
                    this.$router.push({ name: 'welcome' });
                }).finally(() => {
                    this.$store.dispatch('setLoadingOff');
                });
            }
        },
    },
};
